//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { datesToHuman } from "@/utils/dates.js";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "EventDetailCard",
  components: {
    IconView,
    TheMaskIcon,
  },
  props: {
    targetObject: {
      type: Object
    },
    ownerMode: {
      type: Boolean,
      default: false
    },
    shortName: {
      type: Boolean,
      default: false
    },
    showUserName: {
      default: false,
      type: Boolean
    },
    useStorage: {
      type: Boolean
    },
    source: {
      type: String,
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
    bgColor: {
      type: String,
    }
  },
  computed: {
    showCounter() {
      return Number.isInteger(this.targetObject.views)
    },
    label() {
      return this.shortName ? this.targetObject.short_label || this.targetObject.label : this.targetObject.label
    },
    hasDates() {
      return this.targetObject.updated_at && this.targetObject.created_at
    },
    updatedAt() {
      const date = new Date(this.targetObject.updated_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `${day}.${month}.${date.getFullYear()}`
    },
    createdAt() {
      const date = new Date(this.targetObject.created_at)
      const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
      const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
      return `Создано ${day}.${month}.${date.getFullYear()}`
    },
    staticImageUrl() {
      if (!this.targetObject.has_image) return ""

      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(this.targetObject.image)
      } else {
        return `/public/object_images_files/first_image/${this.targetObject.id}/?preview=1`
      }
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'vistat';
    },
    getBg() {
      if (this.bgGradientEnabled && this.bgColor) {
        return `linear-gradient(to ${this.bgGradientDirection}, ${this.bgGradientShadowDirection === 'transparent' ? `${this.bgColor}, transparent` : `${this.bgColor}, ${adjustColorBrightness((this.bgColor), 1.20)}`})`
      } else if (this.bgColor) {
        return this.bgColor;
      }

      return null;
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? null;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? null;
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? null;
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled ?? null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction ?? null;
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
  },
  methods: {
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    getDescription(text) {
      return text.replace(/<\/?[^>]+(>|$)/g, "")
    },
    getDates(event_date) {
      return datesToHuman({
        value: event_date.vfrom,
      }, {
        value: event_date.vto
      }).replace('-', '-<wbr>')
    },
  }
}
